import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

/**
 * COPIAR (Mario, 12-oct; FIC-03): el botoncito junto a un código (transacción, documento, LIQ, lote, referencia…) para
 * pegarlo donde haga falta al resolver un caso. No dispara el clic de la fila o tarjeta donde está.
 *   <app-copiar [texto]="v.liquidacion" etiqueta="la liquidación"></app-copiar>
 */
@Component({
  selector: 'app-copiar',
  templateUrl: './copiar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopiarComponent {
  @Input() texto: string | number | null | undefined;
  @Input() etiqueta: string | null = null;
  copiado = false;

  constructor(private cd: ChangeDetectorRef) { }

  copiar = async (ev: Event): Promise<void> => {
    ev.stopPropagation();
    ev.preventDefault();
    const t = String(this.texto ?? '').trim();
    if (!t) return;
    try { await navigator.clipboard.writeText(t); } catch { return; }
    this.copiado = true; this.cd.markForCheck();
    setTimeout(() => { this.copiado = false; this.cd.markForCheck(); }, 1500);
  };
}
